// extracted by mini-css-extract-plugin
export var option = "_kn-0";
export var optionCard = "_kn-f";
export var optionContent = "_kn-g";
export var optionIcon = "_kn-i";
export var optionIconBox = "_kn-h";
export var optionLabel = "_kn-j";
export var optionPill = "_kn-m";
export var optionPillBadge = "_kn-p";
export var optionPillIcon = "_kn-n";
export var optionPillLabel = "_kn-o";
export var optionRadio = "_kn-k";
export var optionRadioInner = "_kn-l";
export var optionReveal = "_kn-2";
export var optionRevealDelay0 = "_kn-3";
export var optionRevealDelay1 = "_kn-4";
export var optionRevealDelay10 = "_kn-d";
export var optionRevealDelay11 = "_kn-e";
export var optionRevealDelay2 = "_kn-5";
export var optionRevealDelay3 = "_kn-6";
export var optionRevealDelay4 = "_kn-7";
export var optionRevealDelay5 = "_kn-8";
export var optionRevealDelay6 = "_kn-9";
export var optionRevealDelay7 = "_kn-a";
export var optionRevealDelay8 = "_kn-b";
export var optionRevealDelay9 = "_kn-c";
export var optionSelected = "_kn-1";